/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IReducerAction, IReducerActionData } from '../store/types/ReducerTypes';

export const VisualizationChooserActions = {
    VISUALIZATION_CHOOSER_VISIBILITY: 'VISUALIZATION_CHOOSER_VISIBILITY',
    VISUALIZATION_CHOOSER_TAB_COLLAPSED: 'VISUALIZATION_CHOOSER_TAB_COLLAPSED',
    VISUALIZATION_CHOOSER_SELECTED_GROUP: 'VISUALIZATION_CHOOSER_SELECTED_GROUP',
    VISUALIZATION_CHOOSER_SELECTED_TYPE: 'VISUALIZATION_CHOOSER_SELECTED_TYPE'
};

export function setVisualizationChooserVisibility(isVisible: boolean): IReducerAction<IReducerActionData> {
    return {
        type: VisualizationChooserActions.VISUALIZATION_CHOOSER_VISIBILITY,
        data: { isVisible }
    };
}

export function setVisualizationChooserTabCollapsed(isCollapsed: boolean): IReducerAction<IReducerActionData> {
    return {
        type: VisualizationChooserActions.VISUALIZATION_CHOOSER_TAB_COLLAPSED,
        data: { isCollapsed }
    };
}

export function changeSelectedGroup(groupName: string): IReducerAction<IReducerActionData> {
    return {
        type: VisualizationChooserActions.VISUALIZATION_CHOOSER_SELECTED_GROUP,
        data: { groupName }
    };
}

export function changeSelectedVisualizationType(visualizationTypeName: string): IReducerAction<IReducerActionData> {
    return {
        type: VisualizationChooserActions.VISUALIZATION_CHOOSER_SELECTED_TYPE,
        data: { visualizationTypeName }
    };
}
